import { getRandomNegativeId } from "../utils/helpers";
import { CartContentType } from "../utils/enum";

const useConvertCartContentToCartHook = () => {
  return (cartContent: any[]) =>
    cartContent
      ?.filter(
        (order) =>
          order.type === CartContentType.PRODUCT ||
          order.type === CartContentType.CUSTOM
      )
      ?.map((order) => ({
        item_id:
          order.type === CartContentType.CUSTOM
            ? getRandomNegativeId()
            : parseInt(order.menu_item_id),
        name: order.name,
        parent_id: parseInt(order.parent_id) || getRandomNegativeId(),
        price: order.single_price_inc_vat,
        quantity: parseInt(order.quantity),
        vat_percentage: parseInt(order.vat_percentage),
        note: order.note,
        sub_content: order.sub_content ?? [],
        selected_sub_content: order.toppings?.map((topping) => ({
          item_id: topping.menu_item_id
            ? parseInt(topping.menu_item_id)
            : getRandomNegativeId(),
          name: topping.name,
          parent_id: topping.parent_id
            ? parseInt(topping.parent_id)
            : getRandomNegativeId(),
          price: topping.single_price_inc_vat,
          quantity: parseInt(order.quantity),
          vat_percentage: parseInt(order.vat_percentage),
        })),
      }));
};

export default useConvertCartContentToCartHook;
